var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "clamp", function () {
  return $8e747672ba00eedb$export$7d15b64cf5a3a4c4;
});
function $8e747672ba00eedb$export$7d15b64cf5a3a4c4(value, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    min = _ref2[0],
    max = _ref2[1];
  return Math.min(max, Math.max(min, value));
}